<template>
  <div :style="styles.base" @click="handleClickEvent">
    <c-button ref="button" :style="buttonFontStyle"
              v-bind="$props"
              v-bind:text="configurationData.buttonText" />
    <c-base-dialog
      :option="dialogStyle"
      @close="closeDetailModal()"
      v-transfer-dom
      v-model="isShowHistoryPop"
    >
      <template slot="body">
        <div  :class="getCss('pkdetail')">
          <template v-if="rankList.length  === 0">
            <div :class="getCss('empty-status-area')">
              <img  :class="getCss('empty-status-img')"
                   src="https://game.gtimg.cn/images/js/img/tgclub/emptyImageStatus.png" alt="">
              <p   :class="getCss('empty-status-text')"
              >暂无记录</p>
            </div>
          </template>

          <template v-if="rankList.length  > 0 ">
          <div :class="getCss('top')">
            <span>按日期选择</span>
            <div
              @click="onOpenChooseDate"
              :class="getCss('time')" >{{selectDate}}</div>
          </div>
          <div  :class="getCss('content')" >
            <div :class="getCss('itemsTops')" >
              <div :class="getCss('left')" >玩家</div>
              <div :class="getCss('right')" >
                <div  :class="getCss('items')"  v-for="(name,index) in renderRecord.player" :key="index">
                  <p>
                    <span :class="getCss('nickname')" style="text-align:center;">{{name}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div :class="getCss('b-bottom')"  >
              <div  :class="getCss('tTable')"  >
                <div :class="getCss('t-inner')" >

                  <div :class="getCss('itemInner')"   >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>最高评分</span>
<!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.sumScore" :key="index">
                        <p>
                          <span>{{item.value}}</span>
<!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>

                  <div :class="getCss('itemInner')"  >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>淘汰数</span>
<!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.killCount" :key="index">
                        <p>
                          <span>{{item.value}}</span>
<!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>


                  <div :class="getCss('itemInner')"   >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>伤害量</span>
<!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.damageAmount" :key="index">
                        <p>
                          <span>{{item.value}}</span>
<!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>
                  <div :class="getCss('itemInner')"   >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>治疗量</span>
<!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.healAmount" :key="index">
                        <p>
                          <span>{{item.value}}</span>
<!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>

                  <div :class="getCss('itemInner')"   >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>生存时长</span>
<!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.survivalTime" :key="index">
                        <p>
                          <span>{{item.value}}</span>
<!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>

                  <div :class="getCss('itemInner')"   >
                    <div :class="getCss('left')">
                      <div :class="getCss('items')" >
                        <p>
                          <span>局内排名</span>
                          <!--                          <span>对应积分</span>-->
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(item,index) in renderRecord.teamRank" :key="index">
                        <p>
                          <span>{{item.value}}</span>
                          <!--                          <span>{{item.valueScore}}</span>-->
                        </p>
                      </div>
                    </div>
                  </div>


                  <div :class="getCss('itemInnerBottom')" >
                    <div  :class="getCss('left')" >
                      <div :class="getCss('items')"  >
                        <p>
                          <span>总积分</span>
                        </p>
                      </div>
                    </div>
                    <div  :class="getCss('right')" >
                      <div :class="getCss('items')"  v-for="(score,index) in renderRecord.totalScore" :key="index">
                         <p>
                          <span>{{score}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </template>

          <div :class="getCss('tips')" >
            {{configurationData.msgTip}}
          </div>

        </div>
      </template>
    </c-base-dialog>

    <!--    选择时间-->
    <c-base-dialog
      v-model="chooseDateTimeDialog"
      :option="chooseTimePopOption"
      @close="chooseDateTimeDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <c-picker
          :visible="true"
          :data="pureDateArray"
          :maskClic="false"
          :itemHeight="0.9*fontSize"
          :title="'选择时间'"
          :rowNumber="5"
          :cancelText="'取消'"
          :confirmText="'确定'"
          :showToolbar="true"
          @confirm="onConfirmDate"
          @cancel="onCancelDate"
        />
      </template>
    </c-base-dialog>
<!--        选择时间-->

  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
// import CDialog from '../../../../ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import button from '@tencent/ceiba-act-public-button';
import  Picker from './picker';
export default {
  name: 'CTgclubCompetitionHistoryResultNewVersion',
  components: {
    [CDialog.name]: CDialog,
    [button.name]: button,
    [Picker.name]: Picker,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-c-xr-new-',
      isShowHistoryPop: false,
      pageNumber: 1,
      totalPage: 0,
      page: 1,
      currentPageData: [],
      activeDateIndex: 0,
      myInfo: {},
      rankList: [],
      selectDate: '',
      chooseDateTimeDialog: false,
    };
  },
  computed: {
    fontSize() {
      return this.rootFontSize
        ? parseInt(this.rootFontSize.toString().replace('px', ''), 10) : 50;
    },
    renderRecord() {
      const record = {
        player: [],
        sumScore: [],
        killCount: [],
        damageAmount: [],
        healAmount: [],
        survivalTime: [],
        teamRank: [],
        totalScore: [],
      };
      if (this.rankList.length === 0) return  record;
      record.player = this.rankList.map(item => item.player.nickname);
      record.totalScore = this.rankList.map(item => item.total_score);
      record.sumScore = this.rankList.map(item =>  ({
        value: item.sum_score  ?  (item.sum_score / 100).toFixed(1) : 0,
      }));
      record.killCount = this.rankList.map(item =>  ({
        value: item.kill_count,
      }));
      record.damageAmount = this.rankList.map(item =>  ({
        value: item.damage_amount  ?  Math.floor(item.damage_amount / 100) : 0,
      }));
      record.healAmount = this.rankList.map(item =>  ({
        value: item.heal_amount  ?  Math.floor(item.heal_amount / 100) : 0,
      }));
      record.teamRank = this.rankList.map(item =>  ({
        value: parseInt(item.team_rank, 10) || 0,
      }));
      const that = this;
      record.survivalTime = this.rankList.map(item =>  ({
        value: that.survivalTimeFunc(item.survival_time),
      }));
      console.log('---------total history pk  record =', record);
      return record ;
    },
    chooseTimePopOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        width: '7.5rem',
        height: '4.1rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },

    dateTabsStyle() {
      return {
        justifyContent: this.dateTabsData.length <= 5 ? 'center' : 'flex-start',
      };
    },
    dateTabsData() {
      // return   new Array(10).fill({ date: '2.12' });
      return this.currentPageData.map((item) => {
        const { day_ts } = item;
        return {
          date: this.formatDate(day_ts),
        };
      });
    },
    pureDateArray() {
      // return   [
      //   [{ value: '2020-12-12', label: '2020-12-12' },
      //     { value: '2020-12-13', label: '2020-12-13' },
      //     { value: '2020-12-14', label: '2020-12-14' },
      //     { value: '2020-12-15', label: '2020-12-15' },
      //     { value: '2020-12-16', label: '2020-12-16' }],
      // ];
      const res =  this.dateTabsData.map(item =>  ({     value: item.date,
        label: item.date }));
      return [res];
    },
    buttonFontStyle() {
      const { buttonFontStyle, Base } = this.styles;
      return {
        left: 0,
        top: 0,
        ...Base,
        position: 'static',
        ...buttonFontStyle,
      };
    },
    dialogStyle() {
      return  {
        fotter: true,
        header: 'PK榜详情',
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '90vh',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },

  },
  watch: {
    selectDate: {
      handler(newVal) {
        if (!newVal) return;
        if (!this.isShowHistoryPop) return;
        let index  = this.dateTabsData.findIndex(item  => item.date === newVal)  ;
        index = index > -1 ? index : 0 ;
        this.filterTabData(index);
        console.log('newVal', newVal);
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('configurationData= ceiba-act-tgclub-competition-history-result', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      // 初始化按钮1
      this.$refs.button.setClickHandler(this.showHistoryResult, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.isRoleStatusValid,
      });
    },
    survivalTimeFunc(t) {
      const second = parseInt(t, 10);
      if (!second) {
        return  '';
      }
      return  `${(t / 60).toFixed(1)}min`;
    },
    onOpenChooseDate() {
      if (this.pureDateArray.length > 0) {
        this.chooseDateTimeDialog = true;
      }
    },
    onConfirmDate(data) {
      console.log('onConfirmDate = ', data);
      if (!data || !Array.isArray(data) || data.length === 0) {
        return ;
      }
      const { value } = data[0] || {};
      if (value) {
        this.chooseDateTimeDialog = false;
        this.selectDate = value;
      }
    },
    onCancelDate() {
      this.chooseDateTimeDialog = false;
    },
    showHistoryResult() {
      this.getHistoryData();
    },
    filterTabData(newVal) {
      // eslint-disable-next-line no-param-reassign
      // page = page || 1;
      // 获取当前tab数据
      const data = this.currentPageData[newVal] ?? [];
      this.myInfo = data?.myself ?? {};
      this.rankList  = data?.list ??  [];
      // this.rankList =  record.slice((page - 1) * this.pageSize, page * this.pageSize);
      console.log(this.currentPageData, 'myInfo', this.myInfo, 'rankList ', this.rankList);
    },

    closeDetailModal() {
      this.isShowHistoryPop = false;
      this.reportFunc('dialog_close', { stage: '1' });
    },
    async getHistoryData() {
      const { queryHistoryRankListFlowId } = this.configurationData;
      if (queryHistoryRankListFlowId <= 0) return;
      console.log('history data record request page Size form 60 ', queryHistoryRankListFlowId);
      const response = await this.flowRequest({
        flowId: queryHistoryRankListFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            page: 1,
            pageSize: 60,
          }),
        },
      });
      console.log('history data record response  ', response);
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '获取历史战绩失败' });
        return;
      }
      const { info  = '{}', ret: resRet } = data;
      if (!resRet === 0) {
        this.$alert({ msg: '获取历史战绩失败' });
        return;
      }
      const infoData =  info ? JSON.parse(info) : {};
      console.log('history data record response infoData ', infoData);
      const { ret: infoRet, msg: infoMsg } = infoData;
      if (!infoRet === 0) {
        this.$alert({ msg: infoMsg || '获取历史战绩失败' });
        return;
      }
      let { history_list: historyList = []  } = infoData;
      historyList  = historyList || [];
      historyList = historyList.reverse();
      this.totalPage = historyList?.length ?? 0;
      this.currentPageData = historyList;
      if (this.currentPageData.length > 0) {
        const firstDayTimeStamp = this.currentPageData[0]?.day_ts;
        this.selectDate = firstDayTimeStamp ? this.formatDate(firstDayTimeStamp) : '';
      }
      this.isShowHistoryPop = true;
      this.filterTabData(this.activeDateIndex);
      this.reportFunc('dialog_expose', { stage: '1' });
    },
    formatDate(ts) {
      const date = new Date(ts * 1000);
      const month = date.getMonth() + 1;
      const Year = date.getFullYear();
      const day = date.getDate();
      return `${Year}-${month}-${day}`;
    },
    reportFunc(key, eventData) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log('reportFunc sign_up data =', params);
      }
    },
  },
};
</script>
<style lang="scss">
//@import 'vant/lib/style/base.css';
//@import 'vant/lib/loading/index.css';
//@import 'vant/lib/picker/index.css';
@import './styles.scss';
</style>

